import React from "react";
import { Navigate } from "react-router-dom";
import ContainerRedirect from "../../../../../pages/lib/page-redirect";

import ContainerCheckPointListComponent from "../../../../../components/checkpoint/components/list/page";
import ContainerCheckPointAddComponent from "../../../../../components/checkpoint/components/add/page";

export const containerCheckPointRoute = [
  {
    path: "list",
    element: <ContainerCheckPointListComponent />,
  },
  {
    path: "add",
    element: <ContainerCheckPointAddComponent />,
  },
  {
    path: "edit",
    element: <Navigate to="/container/checkpoint/add" />,
  },
  {
    path: "edit/:id",
    element: <ContainerCheckPointAddComponent />,
  },
  {
    path: "",
    element: <ContainerRedirect elroute="/container/checkpoint" />,
  },
];
